import { render, staticRenderFns } from "./healthcareView.vue?vue&type=template&id=629c04a2&scoped=true"
import script from "./healthcareView.vue?vue&type=script&lang=js"
export * from "./healthcareView.vue?vue&type=script&lang=js"
import style0 from "./healthcareView.vue?vue&type=style&index=0&id=629c04a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "629c04a2",
  null
  
)

export default component.exports